import React, { useState } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import Button from './Button'
import { logException } from '../../sentry'

const CopyInput = ({ value }) => {
  const [copied, setCopied] = useState(false)

  // Select all text on focus. Safari needs a delay to work.
  const handleFocus = (e) => {
    const input = e.target
    setTimeout(() => { input.setSelectionRange(0, 9999) }, 1)
  }

  const handleCopy = async () => {
    try {
      await window.navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 5000)
    } catch (error) {
      logException(error)
      window.alert('Kopioiminen epäonnistui. Kopioi valitsemalla linkki ja käyttämällä Ctrl+C tai Cmd+C.')
    }
  }

  return (
    <div className='clipboard-copy-input'>
      <input
        type='text'
        readOnly={ true }
        value={ value }
        onFocus={ handleFocus }
      />
      <Button
        type='button'
        className='button'
        text={ copied ? 'Kopioitu!' : 'Kopioi' }
        onClick={ handleCopy }
      />
    </div>
  )
}

CopyInput.propTypes = exact({
  value: PropTypes.string.isRequired,
})

export default CopyInput
